import { render, staticRenderFns } from "./EPieChart.vue?vue&type=template&id=3b8a442e"
import script from "./EPieChart.vue?vue&type=script&lang=js"
export * from "./EPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports